import React, { FC, useEffect } from "react";
import { useRouter } from "next/router";

import Image from "next/image";
import Label from "components/Label";
import Link from "components/Link";
import { isEmpty } from "utils/array";
import text from "constants/text";
import useScreenSize from "hooks/use-screen-size";
import segment from "lib/segment";
import styles from "./styles.module.scss";

interface Props {
  isSuccess: boolean;
}

const PaymentConfirmation: FC<Props> = ({ isSuccess }) => {
  const { isMobile } = useScreenSize();
  const { success, failure } = text.onboarding.payment_confirmation;
  const { query } = useRouter();

  const { title, description, redirects } = isSuccess ? success : failure;

  useEffect(() => {
    if (query && query.success) {
      segment.track(isSuccess ? "Payment successful" : "Payment error", query);
    }
  }, [isSuccess, query]);

  return (
    <div className={styles.container}>
      <div className={styles.titleWrapper}>
        <Label
          useMarkdown={!isMobile}
          className={styles.title}
          color="white"
          variant="h-centered"
        >
          {title}
        </Label>
      </div>
      <div className={styles.descriptionWrapper}>
        <Label
          useMarkdown={!isMobile}
          color="white"
          variant="s-centered"
          className={styles.description}
        >
          {description}
        </Label>
      </div>
      <div className={styles.appDownload}>
        <Label
          color="white"
          variant="s-centered"
          className={styles.description}
        >
          Download the app:
        </Label>
        <div className={styles.qrCode}>
          <Image
            alt="QR Code"
            className={styles.image}
            src="/app-qr-code.svg"
            width={200}
            height={200}
          />
        </div>
      </div>
      {!isEmpty(redirects) && (
        <div className={styles.redirects}>
          {redirects.map(({ reads, to }) => (
            <Link color="white" className={styles.link} label={reads} to={to} />
          ))}
        </div>
      )}
    </div>
  );
};

export default PaymentConfirmation;
